import PropTypes from "prop-types";
import React, { Component } from "react";

import "../../../../components/servicebot-primary-action.css";

export default class TextOptionElement extends Component {
  holderStyle = {
    width: "100%",
    height: 110,
    overflow: "hidden",
    borderRadius: 15,
    backgroundColor: "rgb(20,126,251)",
    marginRight: 5,
    marginBottom: 15,
    cursor: "pointer",
    margin: "auto",
  };

  labelStyle = {
    bottom: 0,
    width: "50%",
    fontSize: 15,
    textAlign: "center",
    // height: 20,
    backgroundColor: "rgb(20,126,251)",
    fontFamily: '"Open Sans", sans-serif',
    color: "black",
    paddingTop: 5,
    paddingBottom: 5,
    letterSpacing: 3,
    lineHeight: "15px",
    margin: "auto",
  };

  constructor(props) {
    super(props);
    const { color, label, value, text, hideText } = props;

    this.childImageStyle = {
      width: "100%",
      height: "35%",
      transition: "0.6s",
      textAlign: "center",
      paddingTop: 15,
      paddingBottom: 5,
    };

    this.childImageStyle = {
      ...this.childImageStyle,
      height: hideText ? 0 : this.childImageStyle.height,
    };

    this.state = {
      currentStyle: this.childImageStyle,
      color,
      text,
      label,
      value,
      hideText: hideText || false,
    };

    this.holderStyle = { ...this.holderStyle, height: hideText ? 80 : 110 };

    this.zoomIn = this.zoomIn.bind(this);
    this.zoomOut = this.zoomOut.bind(this);
  }

  zoomIn() {
    const { currentStyle } = this.state;
    const newObj = {
      ...currentStyle,
      transform: "scale(1.2) translateY(-5px)",
    };
    this.setState({ currentStyle: newObj });
  }

  zoomOut() {
    this.setState({ currentStyle: this.childImageStyle });
  }

  render() {
    const { currentStyle, label, color, text, value, hideText } = this.state;
    const rotateStyle = {};

    /* hideText: same primary CTA styling as program-select Next (servicebot-primary-action) */
    if (hideText) {
      return (
        <button
          type="button"
          className="servicebot-primary-action servicebot-primary-action--chat-option"
          onClick={() => this.props.clickCallback({ value })}
        >
          {label}
        </button>
      );
    }

    return (
      // biome-ignore lint/a11y/useKeyWithClickEvents: legacy card layout; hideText path uses <button> above
      <div
        style={this.holderStyle}
        onClick={() => this.props.clickCallback({ value })}
        onMouseEnter={() => {}}
        onMouseLeave={() => {}}
      >
        <div
          style={{ ...currentStyle, color, ...rotateStyle }}
          onMouseEnter={this.zoomIn}
          onMouseLeave={this.zoomOut}
        >
          <div
            style={{
              color: "yellow",
              fontSize: 34,
              display: hideText ? "none" : "inline",
            }}
          >
            {text}
          </div>
        </div>
        <div style={{ width: "100%", margin: "auto" }}>
          <div style={this.labelStyle}>{label}</div>
        </div>
      </div>
    );
  }
}

TextOptionElement.defaultProps = {
  hideText: false,
  color: "",
  text: "",
};

TextOptionElement.propTypes = {
  color: PropTypes.string,
  text: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  hideText: PropTypes.bool,
};
